(() => {
  if (window.ziqingHeaderMarketBound) return;
  window.ziqingHeaderMarketBound = true;
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || event.defaultPrevented) return;
    const open = document.querySelector('[data-header-market][open]');
    if (!open) return;
    open.open = false;
    open.querySelector('summary').focus();
    event.preventDefault();
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-header-market][open]').forEach(open => {
      if (!open.contains(event.target)) open.open = false;
    });
  });
  document.addEventListener('focusin', event => {
    document.querySelectorAll('[data-header-market][open]').forEach(open => {
      if (!open.contains(event.target)) open.open = false;
    });
  });
})();
